import bus from './bus'
import * as KomboxConf from './kombox.conf'
import moment from 'moment'

export default {
  
  
  data () {
    return {
      
      editModus: false,
      KomboxConf: KomboxConf,

    }
  },
  
  props: {
    idCompany: null,
    idUser: null,
    kombox: {
      type: Object,
      default:  function () {
        return {
          validTimes:"",
          id:"",
          datetimeShippingEnd:"2029-12-31 00:00:00",
          datetimeShippingBegin:moment().format('YYYY-MM-DD HH:mm:ss'),
          datetimeUpdate:"0000-00-00 00:00:00",
          acl:"1",
          description:"",
          content:"",
          datetimeRegister:"0000-00-00 00:00:00",
          datetimeBegin:moment().format('YYYY-MM-DD HH:mm:ss'),
          datetimeEnd:"2029-12-31 00:00:00",
          idCompany: this.idCompany,
          idParent:"0",
          idUser: this.idUser,
          shippingActiv:"0",
          subType:"11",
          type:"0"
        };
      },
    }
  },
      
  created: function () {
  },

  computed: {
    

  },
  
  methods: {
    
    isShippingActiv: function (kombox) {
      if(typeof kombox.shippingActiv == 'undefined'){
        return false;
      }
      return (kombox.shippingActiv == 3 || kombox.shippingActiv == 1);
    },
    
    
    save: function (kombox) {
      if(!kombox.id){
        this.insert(kombox);
      }else{
        this.update(kombox);
      }
    },
    
  
    insert: function (kombox) {
      this.$http.post(bus.config.path + '/kombox', kombox).then((response) => {
        kombox = response.data;
        this.onInsert(kombox);
      }, (response) => {
        // error callback
      });
      this.editModus = false;
    },
      
    update: function (kombox) {
      this.$http.put(bus.config.path + '/kombox/' + kombox.id , kombox).then((response) => {
        kombox = response.data;
          this.onUpdate(kombox);
      }, (response) => {
          // error callback
      });
      this.editModus = false;
    },
      
    cancel: function (kombox) {
      this.onCancel(kombox);
      this.editModus = false;
    },

    // ToDo move to kombox.common ?
    remove: function (kombox) {
      this.$http.delete(bus.config.path + '/kombox/' + kombox.id ).then((response) => {
        this.onRemove(kombox);
      }, (response) => {
        // error callback
      });
      this.editModus = false;
    },
    
    onInsert: function (kombox) {
      // DO nothing her. Override this Method if necessary
    },
  
    onUpdate: function (kombox) {
      // DO nothing her. Override this Method if necessary
    },
  
    onCancel: function (kombox) {
      // DO nothing her. Override this Method if necessary
    },
  
    onRemove: function (kombox) {
      // DO nothing her. Override this Method if necessary
    },
    

  }
  
}



// WEBPACK FOOTER //
// ./src/common/kombox.common.js